import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useIsArticleDetailPage} from '@aboutyou/router';
import {useCallback} from 'react';

export const useAaMigrationGeneralTest = () => {
  useIsFeatureActive('ab_aa_migration_general', {abTest: true});
};

export const useAaMigrationStreamTest = () => {
  useIsFeatureActive('ab_aa_migration_stream', {abTest: true});
};

export const useAaMigrationAdpTest = () => {
  useIsFeatureActive('ab_aa_migration_adp', {abTest: true});
};

export const useAaMigrationRecoViewportTest = () => {
  const {activateAbTest} = useIsFeatureActive('ab_aa_migration_reco_viewport');

  return {activateAbTest};
};

export const useAaMigrationA2bClickTest = () => {
  const isArticleDetailPage = useIsArticleDetailPage();
  const {activateAbTest: activateAbTestBase} = useIsFeatureActive(
    'ab_aa_migration_a2b_click',
  );

  const activateAbTest = useCallback(() => {
    if (isArticleDetailPage) {
      activateAbTestBase();
    }
  }, [activateAbTestBase, isArticleDetailPage]);

  return {activateAbTest};
};
